import React from 'react';
import ServiceDescriptionSection from '../../components/ServiceDescriptionSection';
import ServiceLegalRepresentationRationale from '../../components/ServiceLegalRepresentationRationale';
import ServiceContactUsSection from '../../components/ServiceContactUs';

const Immigration = () => {
  return (
    <div className='servicePage'>
      <div className='servicePageContent'>
        <div className="header">Immigration Law</div>
        <div className="body">
          <ServiceDescriptionSection
            content="Immigration Law in Australia governs the entry, stay, and rights of non-citizens within the country. This area of law is complex and constantly evolving, with various visa categories available to accommodate different purposes for immigration. Understanding the different types of visas is crucial for individuals seeking to live, study, work, or invest in Australia."
          />
          <ServiceDescriptionSection
            header="Key Visa Categories"
            content={
              <div>
                <ol>
                  <li>
                    <strong>Partner Visa:</strong>
                    <ul>
                      <li>The Partner Visa allows the spouse or de facto partner of an Australian citizen, permanent resident, or eligible New Zealand citizen to live in Australia. There are two primary subclasses:</li>
                      <ul>
                        <li><strong>Subclass 820 (Temporary):</strong> Grants temporary residency while the permanent visa is processed.</li>
                        <li><strong>Subclass 801 (Permanent):</strong> Provides permanent residency after a specified period and meeting eligibility requirements.</li>
                      </ul>
                      <li>Applicants must demonstrate a genuine and ongoing relationship, as well as meet health and character requirements.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Student Visa:</strong>
                    <ul>
                      <li>The Student Visa (Subclass 500) allows international students to study full-time at an approved educational institution in Australia.</li>
                      <li>Key features include:</li>
                      <ul>
                        <li>Students must enroll in a registered course and maintain satisfactory attendance.</li>
                        <li>The visa typically allows for limited work rights while studying.</li>
                        <li>Applicants must demonstrate sufficient funds to cover tuition and living expenses.</li>
                      </ul>
                    </ul>
                  </li>
                  <li>
                    <strong>Visitor Visa:</strong>
                    <ul>
                      <li>The Visitor Visa (Subclass 600) permits individuals to travel to Australia for tourism, visiting family, or business purposes.</li>
                      <li>Important points include:</li>
                      <ul>
                        <li>It generally allows for stays of up to 12 months, depending on the visa grant conditions.</li>
                        <li>Holders cannot engage in paid work or study for more than three months.</li>
                        <li>Applicants must provide evidence of sufficient funds and a genuine intention to visit.</li>
                      </ul>
                    </ul>
                  </li>
                  <li>
                    <strong>Business Investment Visa:</strong>
                    <ul>
                      <li>Business Investment Visas are designed for individuals looking to own and manage a business in Australia or invest in an Australian business.</li>
                      <li>Notable subclasses include:</li>
                      <ul>
                        <li><strong>Subclass 188 (Business Innovation and Investment):</strong> A temporary visa for business owners and investors.</li>
                        <li><strong>Subclass 888 (Business Innovation and Investment):</strong> A permanent visa for those who have successfully operated a business or invested in Australia under the Subclass 188 visa.</li>
                      </ul>
                      <li>Applicants must demonstrate a successful business background and meet specific investment thresholds.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Skilled Visas:</strong>
                    <ul>
                      <li>Skilled Visas are intended for individuals with skills and qualifications that meet Australia's labor market needs.</li>
                      <li>Key subclasses include:</li>
                      <ul>
                        <li><strong>Subclass 189 (Skilled Independent Visa):</strong> A permanent visa for skilled workers not sponsored by an employer.</li>
                        <li><strong>Subclass 190 (Skilled Nominated Visa):</strong> A permanent visa for skilled workers nominated by a state or territory.</li>
                        <li><strong>Subclass 491 (Skilled Work Regional (Provisional) Visa):</strong> A temporary visa for skilled workers nominated by a state or territory to live and work in regional areas.</li>
                      </ul>
                      <li>Applicants must meet a points-based test, demonstrating relevant work experience, qualifications, and English proficiency.</li>
                    </ul>
                  </li>
                </ol>
              </div>
            }
          />
          <ServiceLegalRepresentationRationale
            header="Importance of Legal Representation"
            content={
              <div>
                <div>
                  Navigating immigration law can be complex and challenging. Engaging a qualified immigration lawyer can help individuals:
                </div>
                <ul>
                  <li>Understand visa eligibility requirements and application processes.</li>
                  <li>Prepare and submit visa applications accurately and timely.</li>
                  <li>Address any issues or complications that arise during the immigration process.</li>
                </ul>
              </div>
            }
          />
          <ServiceContactUsSection
            content="If you need assistance with immigration matters, our experienced legal team is here to help. We provide comprehensive advice and support for all visa applications, ensuring you have the best chance of achieving your immigration goals in Australia."
          />
        </div>
      </div>
    </div>
  );
};

export default Immigration;
